// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tool-container-fallback-PuOh_M{color:#f93920;border-bottom:1px solid;border-color:rgba(var(--coze-stroke-5),var(--coze-stroke-5-alpha));align-items:center;width:100%;height:40px;margin-bottom:4px;padding:0 3px;display:flex}.text-ynvALB{margin-left:7px;font-size:14px;font-weight:500;line-height:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tool-container-fallback": `tool-container-fallback-PuOh_M`,
	"toolContainerFallback": `tool-container-fallback-PuOh_M`,
	"text": `text-ynvALB`
};
export default ___CSS_LOADER_EXPORT___;
